import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { ActionButton } from "../../components/ActionButton/ActionButton";
import { apiPost, partitionRows } from "./util";
import { ProposalsContext } from "./ProposalsContext";
import { ErrorMessage } from "./ErrorMessage";
import { ISitrepProposal, IProposalLists, ProposalListPartitioned, IProposalsForEvent } from "./interfaces";

// @ts-ignore
import css from "./non-finalized-proposals.module.scss";
// @ts-ignore
import commonCss from "./common.module.scss";

export const NonFinalizedProposals: React.FC<{}> = () => {

    const [ error, setError, ] = useState();
    const [ list, setList ] = useState<ProposalListPartitioned>();
    const { updateLists, lists: { nonFinalized: rawList, }, } = useContext(ProposalsContext);

    // partition raw list on update

    useEffect(() => {
        if (!rawList) { return; }
        setList(partitionRows(rawList));
    }, [ rawList ]);

    async function handleProposalCheckbox(proposal: ISitrepProposal) {
        const { logId, masterEventId, granted, } = proposal;
        const params = { logId, masterEventId, granted, };
        try {
            const service = granted ? "/unregister" : "/register";
            const lists = await apiPost<IProposalLists>(service, params);
            updateLists(lists);
        } catch (err) {
            setError(err.message);
        }
    }

    function isAnyProposalFinalized({ proposals, eventName }: IProposalsForEvent) {
        return proposals.some(proposal => proposal.granted);
    }

    async function finalize(suite: IProposalsForEvent) {
        if (!isAnyProposalFinalized(suite)) {
            if (!confirm(`Do you really want to dismiss all current proposals for event "${ suite.eventName }", without selecting any of them? These proposals will resurface if another proposal for this event is made.`)) {
                return;
            }
        }
        try {
            const lists = await apiPost<IProposalLists>("/finalize", { masterEventId: suite.eventId });
            updateLists(lists);
        } catch (err) {
            setError(err.message);
        }
    }

    return (
        <div className={ commonCss.proposalsSectionWrapper }>
            <h3>Pending proposals</h3>
            <ErrorMessage message={ error }/>
            {
                (!list || !list.length) ?
                    <p>No pending proposals</p> :
                    <dl className={ css.proposals }>
                        {
                            list.map(suite => {
                                const { latestAction } = suite.proposals.reduce((acc, proposal) => {
                                    if (proposal.handledTs && (!acc._ts || acc._ts > proposal.handledTs)) {
                                        acc.latestAction = {
                                            ts: proposal.handledTs,
                                            by: proposal.handledBy,
                                            byName: proposal.handledByName,
                                        };
                                        acc._ts = proposal.handledTs;
                                    }
                                    return acc;
                                }, {
                                    latestAction: null, _ts: null,
                                });
                                return (
                                    <>
                                        <dt className={ css.proposedEvent } key={ suite.eventId }>
                                            <a href={ `/r/?page=event&id=${ suite.eventId }` }>{ `${ suite.eventName }` }</a>
                                            {
                                                isAnyProposalFinalized(suite) ?
                                                    <ActionButton type="confirm" onClick={ () => finalize(suite) } label="Finalize" /> :
                                                    <ActionButton type="warning" onClick={ () => finalize(suite) } label="Dismiss" />
                                            }
                                        </dt>
                                        {
                                            latestAction && (
                                                <dd className={ commonCss.handledInfo }>
                                                    Handled by <a href={ `/r/?page=profile&id=${ latestAction.by }` }>{ latestAction.byName }</a> at { latestAction.ts }
                                                </dd>
                                            )
                                        }
                                        {
                                            suite.proposals.map(proposal => {
                                                return (
                                                    <dd className={ css.proposedLogEntry } key={ proposal.logId }>
                                                        <div style={ { display: "flex", alignItems: "center" } }>
                                                            <input type="checkbox"
                                                                checked={ proposal.granted }
                                                                onClick={ () => handleProposalCheckbox(proposal) }
                                                                value={ proposal.logId }/>
                                                            <div className={ css.proposedLogEntryLinks }>
                                                                <a href={ `/r/?page=log&logid=${ proposal.logId }` }>Log
                                                                    entry</a>
                                                                { " " }by{ " " }
                                                                <a href={ `/r/?page=profile&id=${ proposal.agentId }` }>{ proposal.agentName }</a>
                                                            </div>
                                                        </div>
                                                    </dd>
                                                );
                                            })
                                        }
                                    </>
                                );
                            })
                        }
                    </dl>
            }
        </div>
    );
};
